import { ThemeProvider } from 'styled-components';
import ErrorBoundary from '@/ErrorBoundary';
import HideOnNative from '@/HideOnNative';
import MainLayout from '@/MainLayout';
import Footer from '@/Search/components/Footer';
import Header from '@/Search/components/Header';
import StickySearchProvider from '@/Search/components/StickySearchProvider';
import FeatureBranch from '@/Search/FeatureBranch';
import theme from '~/theme';
import generateErrorLogger from '~/utilities/errorHandlers';

export default function Search({ initialSeoProps }) {
  return (
    <ThemeProvider theme={theme}>
      <FeatureBranch appName="serenity-ui" />
      <HideOnNative>
        <Header />
      </HideOnNative>
      <ErrorBoundary
        onError={generateErrorLogger('Search Component Error Boundary')}
      >
        <StickySearchProvider>
          <MainLayout initialSeoProps={initialSeoProps} />
        </StickySearchProvider>
      </ErrorBoundary>
      <HideOnNative>
        <Footer />
      </HideOnNative>
    </ThemeProvider>
  );
}
